import { PublicClientApplication } from '@azure/msal-browser';
import { MapProvider, UserProfile } from '@mti/multitenant-ui-shared';
import { AuthenticationError } from './types';

const config = {
  appId: process.env.REACT_APP_MSAL_APP_ID as string,
  redirectUri: process.env.REACT_APP_BASE_URI as string,
  scopes_graph: ['user.read', 'mailboxsettings.read', 'calendars.readwrite'],
  scopes_api: [process.env.REACT_APP_MSAL_TOKEN_AUD + '/apiaccess'],
};

const initClientApplication = () =>
  new PublicClientApplication({
    auth: {
      clientId: config.appId,
      redirectUri: config.redirectUri,
      navigateToLoginRequestUrl: false,
    },
    cache: {
      cacheLocation: 'localStorage',
    },
  });

var publicClientApplication: PublicClientApplication = initClientApplication();
publicClientApplication.initialize();

export const login = async (): Promise<NewUserProfile | null> => {
  try {
    // Login via popup
    await publicClientApplication.handleRedirectPromise();
    let authResult = await publicClientApplication.loginPopup({
      scopes: config.scopes_api,
      prompt: 'select_account',
    });

    return (
      authResult?.account &&
      new NewUserProfile(
        authResult.account.homeAccountId,
        authResult.account.name || '',
        authResult.accessToken,
        authResult.account.username,
        authResult.account.tenantId,
      )
    );
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const logout = async () => {
  publicClientApplication.logout();
};

export const getAuthenticatedUser = async () => {
  try {
    await publicClientApplication.handleRedirectPromise();
    const accounts = publicClientApplication.getAllAccounts();

    if (accounts.length <= 0) return;

    let account = accounts[0];

    let silentResult = await publicClientApplication.acquireTokenSilent({
      scopes: config.scopes_api,
      account: account,
    });

    let accessToken = silentResult?.accessToken;

    return (
      account &&
      new NewUserProfile(
        account.homeAccountId,
        account.name || '',
        accessToken,
        account.username,
        account.tenantId,
      )
    );
  } catch {
    throw new AuthenticationError('Error authenticating user');
  }
};

class NewUserProfile implements UserProfile {
  id: string = '';
  name: string = '';
  accessToken: string = '';
  email: string = '';
  tenantId: string = '';
  organizationId: string = '';
  operatorExtension: string = '';
  mapProvider: MapProvider = { mapProviderType: 0, browserKey: '' };
  expiresOn: number = 0;
  constructor(
    id: string,
    name: string,
    accessToken: string,
    email: string,
    organizationId: string,
  ) {
    this.id = id;
    this.name = name;
    this.accessToken = accessToken;
    this.email = email;
    this.organizationId = organizationId;
  }
}
